define.alias("ember-math-helpers/helpers/atanh", "preview-grid/helpers/atanh");